import { Mail } from 'lucide-react';
import type { ChangeEvent } from 'react';

import InputErrorMessage from '../components/common/InputErrorMessage';
import type { ErrorMessage } from '../helpers/type';

interface EmailInputFieldProps {
  label: string;
  value: string;
  error: ErrorMessage;
  border: string;
  onChange: (e: ChangeEvent<HTMLInputElement>) => void;
  errorLink?: string;
  disabled?: boolean;
}

const EmailInputField = ({
  label,
  value,
  error,
  border,
  onChange,
  errorLink,
  disabled,
}: EmailInputFieldProps) => (
  <div>
    <label htmlFor="email" className="block text-sm font-medium text-gray-700">
      {label}
    </label>
    <div className="mt-1 relative">
      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
        <Mail className="h-5 w-5 text-gray-400" />
      </div>
      <input
        id="email"
        name="email"
        type="email"
        autoComplete="email"
        required
        value={value}
        onChange={onChange}
        disabled={disabled}
        className={`appearance-none block w-full pl-10 pr-3 py-2 border ${border} rounded-md shadow-sm focus:outline-none focus:ring-primary focus:border-primary ${
          disabled ? 'bg-gray-100 cursor-not-allowed' : ''
        }`}
        placeholder="you@example.com"
      />
    </div>
    <InputErrorMessage message={error} link={errorLink} />
  </div>
);

export default EmailInputField;
